export default {
  "slots": {
    "base": "",
    "trigger": [
      "group relative rounded-[calc(var(--ui-radius)/2)] inline-flex items-center gap-1.5 text-(--ui-text-muted) hover:text-(--ui-text) text-sm focus-visible:ring-2 focus-visible:ring-(--ui-primary) focus:outline-none",
      "transition-colors"
    ],
    "triggerIcon": "size-4 shrink-0 group-data-[state=open]:rotate-180 transition-transform duration-200",
    "triggerLabel": "truncate"
  }
}